export const ROUTE_PATHS = {
  FORGOT_PASSWORD: 'forgot',
  RESET_PASSWORD: 'reset_password',
};
